module.exports = __webpack_public_path__ + "img/logo-dark.906f04e7.png";